import React, {Component} from 'react';
import Row from '../../Components/DropzoneRow';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';



class Dropzone extends Component {
    constructor(props, context) {
		super(props, context);

        this.state = {
            rows: []
        }
    }

    render = () => {
        const {dropElements} = this.props;
        let arr = [];
        let count = 0;
        let i = 0;
        let bottomCount = 0;
        let result = dropElements.map((val, index) => {
                if(count == 13)
                {
                    if(bottomCount === 195)
                    {
                        arr.push(<Row  key={index} bottom={true} index={index} value={val} classes="bottom"/>)
                        
                    }else {
                        arr.push(<Row  key={index} right={true} index={index} value={val} classes="right"/>)
                        
                    }
                    
                    
                    count = -1;

                } else if(bottomCount >= 182 && bottomCount <= 196) {
                    
                    arr.push(<Row classes="bottom" key={index} bottom={true} index={index} value={val}/>)
                }
                else {
                    arr.push(<Row  key={index} index={index} value={val}/>) 
                    
                }
                
            bottomCount++;
            count++;
        })
        return (
            <div>
                {
                    arr.map((value, key) => {
                        return value;
                    })
                }
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {};
};
const mapDispatchToProps = (dispatch) => {
  return {};
}; 
export default connect(mapStateToProps, mapDispatchToProps)(Dropzone);


// WEBPACK FOOTER //
// ./src/Components/Dropzone/index.js